import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {MediaInputModel} from '../../../../store/control/state';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useSelector} from 'react-redux';
import {useLocalization} from "../../../../hooks/localization";

type MediaInputExtendedModel = MediaInputModel & { bridge_device_name: string; };

const keyExtractor = (item: MediaInputExtendedModel) => item.id;

export const MediaInputListScreen = memo(function MediaInputListScreen() {
    const {t} = useLocalization();
    const mediaInputList = useSelector(state => state.control.mediaInputList);
    const bridgeDeviceList = useSelector(state => state.control.bridgeDeviceList);

    const mediaInputNewList: MediaInputExtendedModel[] =
        useMemo(() => mediaInputList.map(mediaInput => ({
                ...mediaInput,
                bridge_device_name: bridgeDeviceList.find(bridgeDevice =>
                    bridgeDevice.id === mediaInput.bridge_device_id)?.name || '',
            }),
        ), [mediaInputList, bridgeDeviceList]);

    const [selectedMediaInput, setSelectedMediaInput] = useState<MediaInputModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/settings/media/edit/${selectedMediaInput ? selectedMediaInput.id : ''}`,
            className: 'orange',
            hidden: !(selectedMediaInput),
        },
        {
            text: t('create_remote'),
            url: '/settings/media/edit',
            className: 'green',
        },
    ], [t, selectedMediaInput]);

    const displayNameExtractor = useCallback((item: MediaInputExtendedModel, column: ColumnModel) => {
        if (column.key === 'bridge_device_name') {
            return item.bridge_device_name;
        }

        return item[column.key];
    }, []);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('remote_name'),
            key: 'name',
        },
        {
            length: 2,
            name: t('slot'),
            key: 'slot',
        },
        {
            length: 3,
            name: t('device_name'),
            key: 'bridge_device_name',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl='/settings'>
                <SettingsList
                    columns={columns}
                    items={mediaInputNewList}
                    listType="mediaInputList"
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedMediaInput}
                    onItemSelected={setSelectedMediaInput}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
